// Bounds for the per-location geofence radius (meters) used by Presence Control Center → Geo Location.
//
// IMPORTANT: these values mirror the server-side CHECK constraint in
// `presence-service/src/main/resources/db/migration/V8__add_geofence_radius_to_presence_settings.sql`.
// They MUST be updated together — divergence will surface as confusing 422 responses
// where the UI accepts a value that the server then rejects.
//
// Default (150 m) matches the existing mobile fallback so behavior is unchanged for
// the locations currently storing `NULL`.
export const GEOFENCE_RADIUS_MIN = 50;
export const GEOFENCE_RADIUS_MAX = 1000;
export const GEOFENCE_RADIUS_DEFAULT = 150;
